export default __webpack_public_path__ + "static/media/DanskeHuman-MediumItalic.60ffe57a.eot";